import { api } from "../../../../app/baseQuery";
import { HTTPResponse } from "../../../../common/types/commonTypes";
import { IVendorPaymentReportList } from "../types/VendorPaymentTypes";

export const VendorPaymentReportEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getVendorPaymentReport: build.query<
      HTTPResponse<IVendorPaymentReportList[]>,
      {
        todDate: string;
        formDate: string;
        paymentType: string;
        vendor?: string;
      }
    >({
      query: ({ formDate, todDate, vendor, paymentType }) => {
        let url = `/report/vendor-payment-report/${vendor}?from_date=${formDate}&to_date=${todDate}&payment_type=${paymentType}`;
        return {
          url,
          method: "GET",
        };
      },

      providesTags: [{ type: "vendor-payment-report" }],
    }),
  }),
});

export const { useGetVendorPaymentReportQuery } = VendorPaymentReportEndpoints;
